import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useActiveConversation } from '@avanta/shared/stores/chat/conversations';
import { Trans } from 'react-i18next';
import { SUPPORTER_ID, PSYCHOLOGIST_ID } from 'constants/chat';
import { useIsPatientOrEmployee } from 'stores/user';
import { getUserId } from 'utils/storage';

const WELCOME_MESSAGE_KEYS: Record<string, string> = {
  [PSYCHOLOGIST_ID]: 'Chat.welcomeMessage.psychologist',
  [SUPPORTER_ID]: 'Chat.welcomeMessage.supporter',
};

const getWelcomeMessageKey = (otherUserId?: string): string => {
  const currentUserId = getUserId();
  return (
    (otherUserId && WELCOME_MESSAGE_KEYS[otherUserId]) ||
    (currentUserId && WELCOME_MESSAGE_KEYS[currentUserId]) ||
    ''
  );
};

export const WelcomeMessage = (): React.ReactElement | null => {
  const activeConversation = useActiveConversation();
  const helpMessageKey = getWelcomeMessageKey(activeConversation?.otherUser.id);
  const isPatientOrEmployee = useIsPatientOrEmployee();

  if (!helpMessageKey || !isPatientOrEmployee) return null;

  return (
    <div className="flex gap-2 mb-4 justify-center w-full max-w-full am-lg:max-w-140 mx-auto text-plum-400 text-xs text-center leading-4">
      <Trans
        i18nKey={helpMessageKey}
        ns={LOCIZE_NS.CHAT}
        components={{
          br: <br className="hidden md:inline" />,
        }}
      />
    </div>
  );
};
